<script setup lang="ts">
import type { ObservedSize } from '~/plugins/reisze_observer'
useHead({
  bodyAttrs: {
    //class: 'bg-slate-50 dark:bg-gray-800"',
  },
})

const styleContent = ref({
  '--menubar-height': '45px',
})

const menubarResized = (s: ObservedSize) => {
  styleContent.value = {
    '--menubar-height': s.height + 'px',
  }
}
</script>

<template>
  <TheMenubar
    class="!fixed top-0 left-0 z-40 w-full"
    v-resize="menubarResized"
    :showPopupMenu="false"
  ></TheMenubar>

  <div
    class="flex flex-1 justify-center mt-[var(--menubar-height)]"
    :style="styleContent"
  >
    <div class="bg-background grid h-full flex-col w-full">
      <div class="rounded-lg shadow bg-white mb-2 mr-2 ml-2">
        <div
          class="h-[calc(100svh_-_10px_-_var(--menubar-height))] overflow-y-auto"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
